import { FundOptionProps } from '@sola/schema/lib/schema.js';

// @todo - move somewhere search can use it too without recursive import shannanigans

/**
 * Gets the default amount from suggested amounts array.
 * Priority: isDefault item → second item (index 1) → fallback value
 */
export const getDefaultAmount = (
  suggestedAmounts: FundOptionProps[] | undefined | null,
  fallback: string | number,
): string => {
  return (
    suggestedAmounts?.find((item) => item.isDefault)?.value.toString() ||
    suggestedAmounts?.[1]?.value.toString() ||
    fallback.toString()
  );
};
